import styled from 'styled-components'

import { ImageCustom } from '@/components/shared/image'
import { BodyText } from '@/ui/atoms/body-text'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const FooterAppBannerImage = styled(ImageCustom)(
  ({ theme }) => `
  align-self: flex-end;
  height: 100%;
  max-height: 21.3rem;
  max-width: 13.2rem;
  width: 100%;

  ${MEDIA_QUERIES(theme).medium}{
    max-width: 30.3rem;
    max-height: 50.4rem
  }
`
)

export const FooterAppBannerContainer = styled.article(
  ({ theme }) => `
  background-color: ${theme.colors.purple.light4};
  display: flex;
  gap: ${theme.spacing.defaultSmall};
  justify-content: center;
  padding: 1.2rem 3.8rem 0;


  
  ${MEDIA_QUERIES(theme).medium} {
    
    gap: ${theme.spacing.xLarge};
  }

  ${MEDIA_QUERIES(theme).large} {
    gap: ${theme.spacing.giant};
    padding: ${theme.spacing.large} ${theme.spacing.husky} 0;
  }
  `
)

export const QRCodeContainer = styled.section(
  ({ theme }) => `
  align-items: flex-start;
  background-color: ${theme.colors.purple.light4};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.default};
  justify-content: center;
  margin-bottom: ${theme.spacing.default};
 
  ${MEDIA_QUERIES(theme).medium} {
    align-items: center;
    gap: ${theme.spacing.xLarge};
  }

  `
)

export const CanvasWrapper = styled.section(
  ({ theme }) => `
  align-items: center;
  background-color: ${theme.colors.grey.primary};
  border-radius: ${theme.borderRadius.xLarge};
  color: ${theme.colors.purple.light4};
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.6rem;
  max-width: 23rem;
  min-width: 23rem;
  padding: ${theme.spacing.large};

  ${MEDIA_QUERIES(theme).large}{
    padding-bottom: 0;
  }
  `
)

export const CanvasTitle = styled.section(
  ({ theme }) => `
  align-items: center;
  display: flex;
  gap: ${theme.spacing.defaultSmall};
  justify-content: center;
  text-align: center;
  white-space: nowrap;
`
)

export const CanvasBottomWrapper = styled.section(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  width:100%;
  border-top: .1rem solid ${theme.colors.grey.light1};
  color: ${theme.colors.white};
  padding: 1rem ${theme.spacing.large} 1.2rem;

  & p {
    text-wrap: nowrap;
  }
  `
)

export const CanvasBottomBodyText = styled(BodyText)(
  ({ theme }) => `
  width: 100%;
  color: ${theme.colors.white};
  `
)
